import { Box, Button, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { contentWidth } from "features/landing/landingStyles";

export default function LandingHeader() {
  return (
    <Box component="header" sx={{ bgcolor: "dark.main", color: "white.main" }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ ...contentWidth, minHeight: { xs: 80, md: 96 }, gap: 2 }}
      >
        <Typography
          component={RouterLink}
          to="/"
          sx={{
            color: "inherit",
            fontSize: { xs: "1.2rem", sm: "1.4rem" },
            fontWeight: 700,
            letterSpacing: "-0.06em",
          }}
        >
          Gymplanner
          <Box component="span" sx={{ color: "accent.main" }}>
            .
          </Box>
        </Typography>
        <Stack
          component="nav"
          aria-label="Navegación principal"
          direction="row"
          alignItems="center"
          spacing={4}
        >
          <Link
            href="#funcionalidades"
            color="inherit"
            sx={{ display: { xs: "none", sm: "inline" }, fontSize: "0.8125rem" }}
          >
            Funcionalidades
          </Link>
          <Link
            href="#contacto"
            color="inherit"
            sx={{ display: { xs: "none", md: "inline" }, fontSize: "0.8125rem" }}
          >
            Contacto
          </Link>
          <Button
            component={RouterLink}
            to="/planner/new"
            variant="outlined"
            sx={{
              minHeight: 44,
              px: { xs: 1.5, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              whiteSpace: "nowrap",
              color: "white.main",
              borderColor: "grey.600",
              "&:hover": { borderColor: "white.main", bgcolor: "dark.focus" },
            }}
          >
            Crear rutina
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
